module.exports = __webpack_public_path__ + "img/06jituanhua.c41a342e.png";